import axios from '../../../axiosConfig';

export async function getClients(config = {}) {
    return await axios.get(`/v1/client`, config);
}

export async function getSpecificClients(config = {}) {
    return await axios.get(`/v1/client/specific`, config);
}

export async function getClientById(id, config = {}) {
    return await axios.get(`/v1/client/${id}`, config);
}

export async function getReportingCurrency(config = {}) {
    return await axios.get(`/v1/client/reporting-currencies`, config);
}

export async function getRoles(config = {}) {
    return await axios.get(`/v1/user/roles`, config);
}

export async function createClient(data, config = {}) {
    return await axios.post(`/v1/client`, data, config);
}

export async function updateClient(data, config = {}) {
    return await axios.put(`/v1/client/${data.clientId}`, data.client, config);
}

export async function deleteClient(clientId, config = {}) {
    return await axios.delete(`/v1/client/${clientId}`, config);
}

const functions = { getSpecificClients, getClients, getClientById, createClient, updateClient, deleteClient, getReportingCurrency, getRoles }
export default functions
